//#region Format
export const PHONE_FORMAT: string = '(000) 000-0000';
//#endregion Format

//#region Survey - OtherHealthInsurance - PolicyHolderType
export const POLICYHOLDERTYPE : any = {
    IsSelf:'IsSelf',
    IsSpouse:'IsSpouse',
    IsDependent:'IsDependent',
    IsOther:'IsOther',
};
//#endregion Survey - OtherHealthInsurance - PolicyHolderType


//#region Survery Steps / Routes
export const SURVEYSTEPS_INDEX : any = {
    OTHER_HEALTH_INSURANCE: 0,
    SOCIAL_SECURITY_BENEFIT: 1,
    EMPLOYMENT_STATUS: 2,
    OTHER_BENEFITS: 3,
    SUMMARY: 4
};

export const SURVEYSTEPS_NAMES : any = {
    OTHER_HEALTH_INSURANCE:'otherhealthinsurance',
    SOCIAL_SECURITY_BENEFIT:'socialsecuritybenefits',
    EMPLOYMENT_STATUS:'employmentstatus',
    OTHER_BENEFITS:'otherbenefits',
    SUMMARY: 'summary'
};
//#endregion SurverySteps

//#region Toggle Option
export const NOT_APPLICABLE: string = 'N/A';
//#endregion Toggle Option

//#region Component / Routes
export const PAGES_ROUTES : any = {
    LOGIN: 'login',
    CONTACT_INFORMATION: 'contactinformation',
    CONFIRM_HEALTH_INSURANCE: 'confirmhealthinsurance',
    CONFIRMATION: 'confirmation',
    SURVEY: 'survey'
}
//#endregion Component / Routes

//#region Login Validations
export const LOGIN_VALIDATIONS: any = {
    REFERENCE_NUMBER_MAX_LENGTH: 100,
    LAST_NAME_MAX_LENGTH: 100,
    ZIP_CODE_MAX_LENGTH: 10
}
//#endregion Login Validations

//#region Contact Information
export const CONTACT_INFORMATION_VALIDATIONS: any ={
    EMAIL_MAX_LENGTH: 150,
    USERNAME_MAX_LENGTH: 100
}
//#endregion Contact Information

//#region Other Health Insurance
export const OTHER_HEALTH_INSURANCE_VALIDATIONS: any = {
    INSURANCE_NAME_BENEFICIARY_MAX_LENGTH: 100,
    INSURANCE_MEDICARE_ID_MAX_LENGTH: 30,
    POLICY_MEMBER_NAME_MAX_LENGTH: 100,
    POLICY_MEMBER_IDENTIFICATION_MAX_LENGTH: 30,
    POLICY_HOLDER_OTHER_MAX_LENGTH: 50,
    POLICY_HOLDER_NAME_MAX_LENGTH: 100,
    POLICY_HOLDER_IDENTIFICATION_MAX_LENGTH: 30,
    POLICY_HOLDER_CARRIER_NAME_MAX_LENGTH: 100
}
//#endregion Other Health Insurance

//#region Employment Status
export const EMPLOYMENT_STATUS_VALIDATIONS: any = {
    NAME_MAX_LENGTH: 100,
    EMPLOYER_NAME_MAX_LENGTH: 100
}
//#endregion Employment Status

//#region Employment Status
export const PRIVACY_POLICY: string = 'privacyPolicy';
export const PHONE_NUMBER: string = 'phoneNumber'
//#endregion Employment Status

export const TIMER_OPTIONS: any = {
    MINUTES_10: 600,
    MINUTES_5: 300,
    MINUTES_1: 60,
}

export const NO_SYMBOLS_OR_SPACES_PATTERN : RegExp = new RegExp('^(?:[a-zA-Z0-9]+[^a-zA-Z0-9s]*|[^a-zA-Z0-9s]*[a-zA-Z0-9]+)+$');

export const  UNAUTHORIZED_MESSAGE: string = 'Your session has ended.';

export const COLORS: { [x: string]: string } = {
    'machinify_teal': '#1F3539',
    'machinify_green': '#4ECF99',
    'machinify_seaform': '#CFE9BC',
    'machinify_blue': '#BFD1DD',
    'machinify_black': '#171717',
    'machinify_gray': '#EEEEEE',
    'machinify_off_white': '#F8F8F8',
    'machinify_red': '#D30A0A',
};